<template>
    <div>
        <div class="chatHeader">
            <el-row style="width: 100%;">
                <el-col :span="4">
                    <div  v-if="agentName && arrowVisible" style="padding-left: 10px;">
                        <i class="el-icon-arrow-left" style="color: #fff; font-size: 25px; cursor: pointer;" @click="goBack"></i>
                    </div>
                </el-col>
                <el-col :span="16" :offset="arrowVisible ? 0 : 4">
                    <div style="text-align: center; color: #fff; font-weight: 600;">{{ agentName }}</div>
                </el-col>
                <el-col :span="4">
                    <div style="padding-right: 20px; display: flex; justify-content: flex-end;">
                        <i class="el-icon-close" style="color: #fff; font-size: 25px; cursor: pointer;"
                            @click="handleChatClose"></i>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    name: "ChatListHeader",
    data() {
        return {
            showChatPopup: false,
        };
    },
    components: {
    },
    props: {
        agentName: {
            type: String,
            default: '专属客服'
        },
        arrowVisible: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
    },
    methods: {
        handleChatClose() {
            this.$emit('closeChat')
        },
        goBack() {
            this.$emit("goBack");
        }
    }
};
</script>
<style scoped>
.chatHeader {
    background: var(--baseColor);
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px 10px 0px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/module/chat/components/chatListHeader.vue